import Container from './Container';
import DisplayObject from './DisplayObject';
import Sprite from './Sprite';
import Graphics from './Graphics';
import Text from './Text';

/**
 * @namespace PIXI
 */
export default {
    Container,
    DisplayObject,
    Sprite,
    Graphics,
    Text
};